import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/site/PageHeader";
import { ServicesGrid } from "@/components/site/ServicesGrid";
import { CTASection } from "@/components/site/CTASection";
import { SERVICES } from "@/data/site";

export const Route = createFileRoute("/services")({
  head: () => ({
    meta: [
      { title: "Painting Services in Wisconsin — Michael's Painting" },
      { name: "description", content: "Interior, exterior, cabinet, drywall, commercial, new construction, staining, and color consultation services across Wisconsin." },
      { property: "og:title", content: "Painting Services in Wisconsin" },
      { property: "og:description", content: "Full-service residential and commercial painting in Wisconsin." },
      { property: "og:url", content: "https://michaelspaintingwi.com/services" },
    ],
    links: [{ rel: "canonical", href: "https://michaelspaintingwi.com/services" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Painting Contractor",
          provider: {
            "@type": "LocalBusiness",
            name: "Michael's Painting",
            url: "https://michaelspaintingwi.com",
            telephone: "+1-608-886-4598",
            email: "michaelspainting0@gmail.com",
            image: "https://michaelspaintingwi.com/og-cover.jpg",
            address: {
              "@type": "PostalAddress",
              streetAddress: "4012 Terminal Dr",
              addressLocality: "McFarland",
              addressRegion: "WI",
              postalCode: "53558",
              addressCountry: "US",
            },
          },
          areaServed: [
            "Madison, WI", "Middleton, WI", "Fitchburg, WI", "Verona, WI",
            "Sun Prairie, WI", "Waunakee, WI", "Stoughton, WI",
          ],
          hasOfferCatalog: {
            "@type": "OfferCatalog",
            name: "Painting Services",
            itemListElement: SERVICES.map((s) => ({
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: s.title,
                description: s.desc,
              },
            })),
          },
        }),
      },
    ],
  }),
  component: ServicesPage,
});

function ServicesPage() {
  return (
    <>
      <PageHeader eyebrow="Services" title="Everything we do, done with the same standard." subtitle="A complete catalog of residential and commercial painting services across Wisconsin." />
      <ServicesGrid title="Our full service catalog" subtitle="Tap any service and we'll tailor a proposal to your project." />
      <CTASection />
    </>
  );
}
